import { LookbookSettingsDelwinMenuItemTooltipContent } from '@app/components/lookbook/LookbookSettingsPage/components';
import { Calendar, PreorderWithDates, Stock, StockWithDates } from '@app/components/various/Icons';
import { Tooltip } from '@app/components/various/Tooltip';
import { isRunning } from '@app/logic/deliveryWindows';
import { isEmpty } from '@app/utils/isEmpty';
import { DeliveryWindow } from '@typings';
import React from 'react';

interface Props {
  deliveryWindow: DeliveryWindow.Mixed;
}

const preventDefault = (evt: React.UIEvent) => {
  evt.stopPropagation();
  evt.preventDefault();
};

export const LookbookSettingsDelwinMenuItem = ({ deliveryWindow }: Props) => {
  const Icon = React.useMemo(() => {
    if (isRunning(deliveryWindow)) {
      return deliveryWindow.stockType === 'stock' ? Stock : Calendar;
    }

    return deliveryWindow.stockType === 'stock' ? StockWithDates : PreorderWithDates;
  }, [deliveryWindow]);

  return (
    <span className="flex items-center gap-2 overflow-hidden">
      <Tooltip content={<LookbookSettingsDelwinMenuItemTooltipContent deliveryWindow={deliveryWindow} />}>
        <span className="ml-1 mr-0.5 inline-flex cursor-pointer items-center" role="presentation" onClick={preventDefault}>
          <Icon />
        </span>
      </Tooltip>
      <span className="overflow-hidden text-ellipsis body-2">{!isEmpty(deliveryWindow.name) ? deliveryWindow.name : '-'}</span>
    </span>
  );
};
